export default {
  menu: {
    sports: "Olahraga",
    referAndEarn: "Ajak dan Dapatkan",
    referDesc: "komisi hingga 60%",
    copyLink: "Salin Tautan",
    hot: "Populer",
    favorites: "Favorit",
    recent: "Terbaru",
    vipClub: "Klub VIP",
    bonus: "Bonus",
    bonusGames: "Permainan Bonus",
    affiliate: "Afiliasi",
    promotion: "Promosi",
    rewards: "Hadiah",
    help: "Bantuan",
    feedback: "Umpan Balik",
    downloadApp: "Unduh Aplikasi",
    claimBonus: "Klaim Bonus",
    redeemCode: 'Tukar Kode',
    redeemDesc: 'Klaim Hadiah Gratis Anda',
    liveSupport: "Dukungan Langsung",
    language: "Bahasa",
	search: "search"
  }
}
